import {useGuestVariables} from 'Event'
import {useLeftyTemplate} from 'Event/template/Lefty'
import TitleConfig from 'Event/template/Lefty/ForgotPassword/Title/TitleConfig'
import {TitleBase} from 'Event/template/Lefty/Login/Title'
import Configurable from 'organization/Event/Configurable'
import React from 'react'

export default function Title() {
  const {
    login: {
      passwordReset: {forgotPasswordTitle},
    },
  } = useLeftyTemplate()
  const v = useGuestVariables()

  return (
    <Configurable>
      <TitleConfig />
      <TitleBase>{v(forgotPasswordTitle)}</TitleBase>
    </Configurable>
  )
}
